export default __webpack_public_path__ + "static/media/scheduled-calls-tour.330fa6ce.png";